import BossModel from "@/models/BossModel";
import Download from "@/models/Download/Download";

export default class ProposalDownload extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'proposal/download';

    /**
     *
     * @type {string}
     */
    static entity = 'proposalDownloads';

    static fields() {
		return {
			id: this.attr(null),
			proposal_id: this.attr(null),
			download_id: this.attr(null),
			is_active: this.attr(null),
            download: this.belongsTo(Download, 'download_id'),
		}
	}

    /**
     *
     */
    Deactivate(){
        this.is_active = 0;
        this.api().update();
    }

    /**
     *
     */
    Activate(){
        this.is_active = 1;
        this.api().update();
    }

    /**
     *
     * @returns {boolean|*}
     */
    Download() {
        return this.getRelated('download');
    }

}
